export interface DictionaryCurrencyEntity {
  Id: number | undefined;
  Code: string;
}

